import React from "react";
import moment from "moment";
import { Carousel } from "react-responsive-carousel";

function FeedCard({
  detailed,
  feedLink,
  type,
  media,
  feedId,
  approved,
  archived,
  deleted,
  date,
  feedMessage,
  headline,
  likes,
  location,
  members,
  onClick,
  userId, ...props }) {

  return (
    <div className={`${type === 'sm' ? 'w-1/6' : 'w-full'} project-card`} onClick={onClick}>
      <div className={detailed ? "project-card-view" : "project-card-view-small"}>
        {detailed && <>
          {media?.length === 1 ? <img src={media[0].path} alt="card-img" className="w-full" /> :
            <Carousel
              autoPlay={true}
              infiniteLoop={true}
              showThumbs={false}
              swipeable={true}
              interval={5000}
              stopOnHover={true}
              showIndicators={false}
              showArrows={false}
            >
              {
                media.map((item, index) => <img src={item.path} alt="Image Loading" key={index} className="w-full" />)
              }
            </Carousel>}</>}
        <div className="p-4">
          {!detailed && <>
            <h1 className="project-heading2">
              {headline} <strong className="mainText">  </strong>
            </h1>
            <p><span className="mainText">{moment(date, 'DD/MM/YYYY').format('LL')}</span></p>
          </>}
          <p style={{ textAlign: "justify" }}>
            <span> {feedMessage} </span>
          </p>
          <p style={{ textAlign: "justify" }}>
            Place : <span className="mainText">{location}</span>
          </p>
          <div className="cardRow">
            <p style={{ textAlign: "justify" }}>
              Presence Of : <span className="mainText">{members && members.join(', ')}</span>
            </p>
            {likes && <p style={{ textAlign: "justify" }}>
              Views : <span className="mainText">{likes}</span>
            </p>}
          </div>
        </div>
      </div>
    </div>
  );
}
export default FeedCard;
